export default __webpack_public_path__ + "static/media/notifications.e73a5bbf.svg";